// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TdsFormRepoConfig from "./TdsFormRepoConfig.bs.js";

var dummyResponse = {
        "type": "owner_driver",
        "payment_owner": {
          "uuid": "test uuid",
          "mobile": "test mobile",
          "name": "test name",
          "pan_number": "test pan",
          "geo_region_name": "Mumbai",
          "address": "test address"
        },
        "financial_year_start_date": "2018-04-01",
        "financial_year_end_date": "2019-03-31",
        "deadline_date": "2019-06-25",
        "requested_at": 0,
        "instruction_title": "string",
        "instruction_details": "string",
        "form_url": "string",
        "declaration_url": "https://porter-pdf-dev.s3.ap-southeast-1.amazonaws.com/tds-declaration/tds_declaration_cef0cbcf-a22e-4c2e-b0a5-ae37613e78622019-20.pdf",
        "status": "pending",
        "wallet_withdrawal_revoked": true
      };

function fetchTdsFormData(uuid) {
  Logger$Catalyst.trace({
        requestUrl: "fetchTdsFormDataApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TdsFormRepoConfig.TdsFormConverter.execute, result);
                            });
                }), "");
}

var dummySubmissionResponse = {
        "status": true,
        "message": "https://porter-pdf-dev.s3.ap-southeast-1.amazonaws.com/tds_declaration_test.pdf"
      };

function submitTdsForm(data) {
  Logger$Catalyst.trace({
        requestUrl: "submitTdsFormApiCalled"
      });
  Logger$Catalyst.debug({
        payload: data
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummySubmissionResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TdsFormRepoConfig.TdsSubmissionConverter.execute, result);
                            });
                }), "");
}

var DummyTdsFormRepo = {
  dummyResponse: dummyResponse,
  fetchTdsFormData: fetchTdsFormData,
  dummySubmissionResponse: dummySubmissionResponse,
  submitTdsForm: submitTdsForm
};

export {
  DummyTdsFormRepo ,
  
}
/* NetworkUtils Not a pure module */
